import { FormProvider } from 'react-hook-form';
import { FormInput } from '@/components/form/form-input';
import { FormAsyncLocationSelect } from '@/components/form/form-async-location-select';
import { SmartSuggestionFormShell } from '@/features/inventory/pages/smart-suggestion/form-shell';
import { useResellerForm } from '../../hooks/reseller-setting-hooks';

const ResellerForm = () => {
  const {
    id,
    form,
    isLoading,
    createMutation,
    editMutation,
    handleReset,
    handleDelete,
    onSubmit,
  } = useResellerForm();

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <SmartSuggestionFormShell
          id={id}
          title={id ? 'Edit Reseller' : 'New Reseller'}
          description="A partner that sells bookings for the locations picked here."
          isLoading={!!id && isLoading}
          isSaving={createMutation.isPending || editMutation.isPending}
          onSubmit={form.handleSubmit(onSubmit)}
          onReset={handleReset}
          onDelete={handleDelete}
        >
          <FormInput
            name="name"
            label="Reseller Name"
            placeholder="e.g. Travel Partner"
            required
          />

          <FormInput
            name="contactPerson"
            label="Contact Person"
            placeholder="e.g. Johnson"
            required
          />

          <FormInput
            name="email"
            label="Email"
            placeholder="e.g. alex.johnson@email.com"
            required
          />

          <FormInput
            name="phoneNumber"
            label="Phone Number"
            placeholder="e.g. +31 6 12345678"
            required
          />

          <FormAsyncLocationSelect<true>
            name="branchId"
            label="Location"
            placeholder="Select location(s)"
            isMulti
            required
          />
        </SmartSuggestionFormShell>
      </FormProvider>
    </div>
  );
};

export default ResellerForm;
